import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheck3 = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 19,
	height: 15,
	viewBox: "0 0 19 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M18.1166 2.30581L6.11658 14.3058L0.616577 8.80581L2.02658 7.39581L6.11658 11.4758L16.7066 0.895813L18.1166 2.30581Z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgCheck3);
export { ForwardRef as ReactComponent };
